<template>
  <v-app>
    <BackToTop bottom="50px" right="50px">
      <v-btn round color="info">
        <v-icon>arrow_upward</v-icon>
      </v-btn>
    </BackToTop>
    <template
      v-if="$keycloak.authenticated && $keycloak.hasRealmRole('general')"
    >
      <router-view v-if="computedNoNavigation" />
      <template v-else>
        <NavigationDrawer />
        <Rightbar />
        <Navbar />
        <v-content>
          <div id="conveyancingsummary" />
          <Searchbar />
          <Salesbar />
          <Fundviewbar />
          <v-container>
            <router-view />
          </v-container>
          <Footer />
        </v-content>
      </template>
    </template>
    <template v-else>
      <v-container>
        <router-view />
      </v-container>
    </template>
  </v-app>
</template>

<script>
import BackToTop from "vue-backtotop";
import Navbar from "./components/layout/Navbar";
import NavigationDrawer from "./components/layout/NavigationDrawer";
import Searchbar from "./components/layout/Searchbar";
import Salesbar from "./components/layout/Salesbar";
import Fundviewbar from "./components/layout/Fundviewbar";
import Rightbar from "./components/layout/Rightbar";
import Footer from "./components/layout/Footer";
export default {
  name: "App",
  components: {
    BackToTop,
    Navbar,
    NavigationDrawer,
    Searchbar,
    Fundviewbar,
    Salesbar,
    Rightbar,
    Footer
  },
  computed: {
    computedNoNavigation() {
      const routes = ["revision", "planner"];
      if (routes.includes(this.$route.name)) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
.department0 {
  color: black;
}

.department1 {
  color: green;
}

.department2 {
  color: orange;
}

.department3 {
  color: red;
}

.department7 {
  color: #663399;
}

.headerDepartment1 {
  background: lighten(green, 60%);
  padding: 15px;
}

.headerDepartment2 {
  background: lighten(orange, 40%);
  padding: 15px;
}

.headerDepartment3 {
  background: lighten(red, 40%);
  padding: 15px;
}

.headerDepartment7 {
  background: lighten(#663399, 40%);
  padding: 15px;
}

.oldMessage1 {
  padding: 5px;
  background: #ffdddd;
}

.oldMessage2 {
  padding: 5px;
  background: #ffcccc;
}

div.ajaxForm {
  background: #ddddff;
  padding: 10px;
  margin-top: 5px;
}

span.ajaxForm {
  background: #ddddff;
}

.uppercase {
  text-transform: uppercase;
}

.booleanStrongTrue {
  background: green;
  color: white;
  font-weight: bold;
}

.booleanStrongFalse {
  color: red;
}

table.basic {
  font-size: 0.75em;
  border-spacing: 0;
  border-collapse: collapse;
}

table.basic th {
  background: #999999;
  color: white;
  text-align: center;
  border: 1px solid #dddddd;
  padding: 1px;
}

table.basic td {
  vertical-align: top;
  border: 1px solid #dddddd;
  padding: 1px;
}

table.basic2 {
  border-spacing: 0;
  border-collapse: collapse;
}

table.basic2 th {
  background: #999999;
  color: white;
  text-align: center;
  border: 1px solid #dddddd;
  padding: 1px;
}

table.basic2 td {
  vertical-align: top;
  border: 1px solid #dddddd;
  padding: 1px;
}
</style>
